<template>
  <div>
    <van-nav-bar
      title="添加俱乐部"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />

    <van-form @submit="onSubmit">

      <van-field
        clearable
        v-model="ClubName"
        name="ClubName"
        label="俱乐部名"
        placeholder="俱乐部名"
        :rules="[{ required: true, message: '请填写俱乐部名' }]"
      />

      <van-field
        clearable
        v-model="Location"
        name="Location"
        label="俱乐部地点"
        placeholder="俱乐部地点"
        :rules="[{ required: true, message: '请填写俱乐部地点' }]"
      />

      <van-field
        readonly
        clickable
        :value="startTime"
        name="startUnixTime"
        label="选择时间"
        placeholder="点击选择俱乐部开始选择时间"
        @click="startTimeShowPicker = true"
      />

      <van-popup v-model="startTimeShowPicker" position="bottom">
        <van-datetime-picker
          v-model="currentDate"
          type="datetime"
          title="选择俱乐部开放加入时间"
          :min-date="minDate"
          :max-date="maxDate"
          @confirm="startOnConfirm"
          @cancel="startTimeShowPicker = false"
        />
      </van-popup>

      <van-field
        readonly
        clickable
        name="tecnameandnum"
        :value="tecnameAndNumValue"
        label="负责教师"
        placeholder="点击选择负责教师"
        @click="tecnameshowPicker = true"
      />

      <van-popup class="popup" v-model="tecnameshowPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="getTecNameAndNum"
          @confirm="tecnameOnConfirm"
          @cancel="tecnameshowPicker = false"
        />
      </van-popup>

      <van-cell title="最大人数">
        <van-stepper theme="round" v-model="maxp" integer/>
      </van-cell>

      <van-field
        v-model="introduction"
        rows="2"
        autosize
        name="introduction"
        clearable
        label="简介"
        type="textarea"
        maxlength="500"
        placeholder="俱乐部简介"
        show-word-limit
        :rules="[{ required: true, message: '请填写俱乐部简介' }]"
      />

      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit">
          添加俱乐部
        </van-button>
      </div>

      <div style="padding: 30px"></div>
    </van-form>
  </div>
</template>

<script>
import {getTeacherList} from "network/teacher"
import {AddClub} from "network/club"
import Vue from 'vue';
import {
  NavBar,
  Form,
  Field,
  Button,
  Picker,
  Popup,
  Dialog,
  Col,
  Row,
  DatetimePicker,
  Uploader,
  Stepper,
  Cell
} from 'vant';

Vue.use(Form);
Vue.use(NavBar);
Vue.use(Field);
Vue.use(Button);
Vue.use(Picker);
Vue.use(Popup);
Vue.use(Dialog);
Vue.use(Col);
Vue.use(Row);
Vue.use(DatetimePicker);
Vue.use(Uploader);
Vue.use(Stepper);
Vue.use(Cell);
export default {
  name: "AddClub",
  data() {
    return {
      //Club Name
      ClubName: "",

      //Club Location
      Location: "",

      //Maximum number of people
      maxp: 1,

      //Rush Course time
      startTime: '',
      startTimeShowPicker: false,
      currentDate: new Date(),
      minDate: new Date(),
      maxDate: this.GLOBAL.end_select_time,
      startUnixTime: '',

      //Teacher and Teacher`s number
      teachers: [],
      tecnameAndNumValue: '',
      tecnameshowPicker: false,
      columns: ['男', '女'],

      //Course introduction
      introduction: "",
    }
  },
  activated() {
    getTeacherList().then(res => {
      this.teachers = [];
      this.teachers.push(...res);
    });
  },
  computed: {
    getTecNameAndNum() {
      return this.teachers.map(value => value.id + ':' + value.tName + ':' + value.tNum + ':' + value.gender);
    }
  }
  ,
  methods: {
    Dialoginfo(title, message) {
      Dialog.alert({
        title,
        message
      }).then(() => {
        // on close
      });
    }
    ,
    onClickLeft() {
      this.$router.replace("/club");
    },
    tecnameOnConfirm(value) {
      this.tecnameAndNumValue = value;
      this.tecnameshowPicker = false;
    },
    onSubmit(values) {
      let times = new Date();
      let createDate = times.getFullYear() + '-' + (times.getMonth() + 1) + '-' + times.getDate() + '-' + times.getHours() + '-' + times.getMinutes() + '-' + times.getSeconds() + ':' + times.getTime();
      if (values.ClubName === "") {
        this.Dialoginfo('提示', '俱乐部名不能为空');
      } else if (this.Location === "") {
        this.Dialoginfo('提示', '俱乐部位置不能为空');
      } else if (values.startUnixTime === "") {
        this.Dialoginfo('提示', '俱乐部开放加入时间不能为空');
      } else if (values.tecnameandnum === "") {
        this.Dialoginfo('提示', '教师不能为空');
      } else if (values.introduction === "") {
        this.Dialoginfo('提示', '俱乐部简介不能为空');
      } else {
        AddClub(values.ClubName, values.Location, values.tecnameandnum, this.maxp, this.introduction, this.startUnixTime, createDate).then(res => {
          if (res) {
            this.Dialoginfo('提示', '添加成功');
            this.maxp = 0;
            this.ClubName = "";
          } else {
            this.Dialoginfo('提示', '添加失败,俱乐部名称可能重复。');
          }
        });
      }
    },
    startOnConfirm(value) {
      this.startUnixTime = value.getTime().toString();
      this.startTime = value.toLocaleString();
      this.startTimeShowPicker = false;
    },
  }
}
</script>

<style scoped>

</style>
